// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.AVI = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.AVI = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var AVI = _exports.AVI = function AVI(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.927 8.49609V16.9268C16.927 17.4779 16.7081 18.0065 16.3184 18.3961C15.9287 18.7858 15.4002 19.0048 14.8491 19.0048H5.15214C4.60104 19.0048 4.07251 18.7858 3.68283 18.3961C3.29314 18.0065 3.07422 17.4779 3.07422 16.9268V3.07402C3.07422 2.52292 3.29314 1.99439 3.68283 1.6047C4.07251 1.21502 4.60104 0.996094 5.15214 0.996094H9.42703C9.79431 0.996149 10.1465 1.14205 10.4063 1.40172L16.5214 7.51687C16.7811 7.7766 16.927 8.12882 16.927 8.49609Z",
      stroke: "#212B36",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 1.3418V6.5366C10 6.904 10.1459 7.25635 10.4057 7.51614C10.6655 7.77593 11.0179 7.92188 11.3853 7.92188H16.5801",
      stroke: "#212B36",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.02879 16L6.28986 15.1602H7.65707L7.91814 16H8.94693L7.61066 12H6.33627L5 16H6.02879ZM6.51805 14.4258L6.95703 13.0078H6.98797L7.42888 14.4258H6.51805Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.74076 12H8.66942L10.0057 16H11.2801L12.6164 12H11.545L10.6593 14.9297H10.6265L9.74076 12Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14 12H13.0428V16H14V12Z",
      fill: "#212B36"
    }));
  };
});
